import { NgModule } from '@angular/core';
import { EncodingService } from './encoding.service';
import { EncryptionService } from './encryption.service';

@NgModule({
  imports: [],
  providers: [EncodingService, EncryptionService],
})
export class CryptoModule {}
